import { render, staticRenderFns } from "./CateSelect.vue?vue&type=template&id=06baa7a5&scoped=true&"
import script from "./CateSelect.vue?vue&type=script&lang=js&"
export * from "./CateSelect.vue?vue&type=script&lang=js&"
import style0 from "./CateSelect.vue?vue&type=style&index=0&id=06baa7a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06baa7a5",
  null
  
)

export default component.exports